(() => {
  function setup(root) {
    if (root.dataset.galriePurchaseReady) return;
    root.dataset.galriePurchaseReady = 'true';
    const price = root.querySelector('[id^="price-"]');
    const sync = () => {
      const amount = price?.querySelector('[data-galrie-variant-price]')?.dataset.galrieVariantPrice;
      const buttonPrice = root.querySelector('[data-galrie-button-price]');
      const reference = price?.querySelector('[data-galrie-variant-price]')?.dataset.galrieVariantCompare;
      if (buttonPrice && amount) {
        const sale = document.createElement('span');
        sale.textContent = amount;
        if (reference) {
          const regular = document.createElement('s');
          regular.textContent = reference;
          regular.style.marginInlineEnd = '0.4em';
          buttonPrice.replaceChildren(regular, sale);
        } else buttonPrice.replaceChildren(sale);
      }
      const returnTo = root.querySelector('.galrie-welcome-form [name="return_to"]');
      const variant = root.querySelector('product-form [name="id"]')?.value;
      if (returnTo && variant) {
        const target = new URL(returnTo.value, location.origin);
        target.searchParams.set('variant', variant);
        returnTo.value = target.pathname + target.search + target.hash;
      }
    };
    if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true });
    root.addEventListener('change', () => requestAnimationFrame(sync));
    const assurance = root.querySelector('.galrie-assurance-dialog');
    root.querySelector('[data-galrie-assurance-open]')?.addEventListener('click', () => assurance?.showModal());
    assurance?.querySelector('[data-galrie-assurance-close]')?.addEventListener('click', () => assurance.close());
    assurance?.addEventListener('click', event => {
      if (event.target !== assurance) return;
      const box = assurance.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) assurance.close();
    });
    sync();
  }
  document.querySelectorAll('.galrie-pdp-designed').forEach(setup);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.galrie-pdp-designed').forEach(setup);
  });
})();
